/**
* Explore Rooms JS
* -----------------------------------------------------------------------------
*
* All the JS for the Explore Rooms component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'explore-rooms',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.explore-rooms' ).each( function( key, component ) {
        const navSplide = new Splide( $( component ).find( '.splide--explore-rooms--navigation' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '12px',
          autoWidth: true,
          isNavigation: true,
          direction: window.isRtl ? 'rtl' : 'ltr',

        } );

        const roomsSplide = new Splide( $( component ).find( '.splide--explore-rooms--rooms' )[0], {
          type: 'fade',
          pagination: false,
          arrows: false,
          gap: '12px',
          perPage: 1,
          drag: false,
          direction: window.isRtl ? 'rtl' : 'ltr',

        } );

        roomsSplide.sync( navSplide );
        roomsSplide.mount();
        navSplide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'explore-rooms', COMPONENT );
} )( app );
